// role
export const USER_ADMIN = 'ADMIN';
export const PURCHASER = 'PURCHASER';

// quote
export const IS_VIEW_ONLY_QUOTE = 1;
export const EXPIRED_QUOTE = 'expired';
export const IS_ONLINE_QUOTE = 'Digital';

export const UNAUTHORIZED = 'UNAUTHORIZED';

export const DEFAULT_ROWS_PER_PAGE = 20;

// session storage
export const QUOTE_PROJECT_ID = 'quote-project-id';

// email options
export const PRINT_WITH_NO_PRICE = 'nopriceordiscounts';
export const PRINT_WITH_PRICE_DISCOUNT = 'priceanddiscounts';
export const PRINT_WITH_PRICE_ONLY = 'priceonly';
